import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

function Thumbnail({ errorIconClass, thumbnailUrl, imgClassName, containerClass }) {
  const wrapperClass = ClassNames('thumbnail-2d-container', errorIconClass, containerClass);
  const [thumbnailClass, setThumbnailClass] = useState(ClassNames(imgClassName, 'loading'));

  const imageLoad = () => {
    setThumbnailClass(imgClassName);
  };
  return (
    <span className={wrapperClass}>
      {thumbnailUrl && (
        <img className={thumbnailClass} src={thumbnailUrl} alt='' onLoad={imageLoad} />
      )}
    </span>
  );
}

Thumbnail.defaultProps = {
  errorIconClass: '',
  thumbnailUrl: '',
  imgClassName: '',
  containerClass: ''
};

Thumbnail.propTypes = {
  errorIconClass: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  imgClassName: PropTypes.string,
  containerClass: PropTypes.string
};

export default Thumbnail;
